document.addEventListener("DOMContentLoaded", initWishlist);

document.addEventListener("shopify:section:load", initWishlist);

document.addEventListener("wishlist:updated", function () {
    updateButtons();
    updateCounter();
});

function initWishlist() {

    updateButtons();
    updateCounter();

    document.querySelectorAll(".wishlist-btn").forEach(button => {

        if (button.dataset.bound) return;

        button.dataset.bound = "true";

        button.addEventListener("click", function (e) {

            e.preventDefault();
            e.stopPropagation();

           const product = {

    id: this.dataset.productId,

    handle: this.dataset.productHandle,

    variantId: this.dataset.variantId,

    title: this.dataset.productTitle,

    url: this.dataset.productUrl,

    image: this.dataset.productImage,

    price: this.dataset.productPrice,

    comparePrice: this.dataset.productComparePrice

};

            const added = Wishlist.toggle(product);

            if (added) {

                this.classList.add("active");

                heartBurst(e.clientX, e.clientY);

                showToast("Added to Wishlist ❤️");

            } else {

                this.classList.remove("active");

                showToast("Removed from Wishlist");

            }

        });

    });

}

function updateButtons() {

    document.querySelectorAll(".wishlist-btn").forEach(button => {

        button.classList.toggle(
            "active",
            Wishlist.exists(button.dataset.productId)
        );

    });

}

function updateCounter() {

    const total = Wishlist.count();

    document.querySelectorAll(".wishlist-count").forEach(counter => {

        counter.textContent = total;

        counter.style.display = total ? "flex" : "none";

    });

}

function heartBurst(x, y) {

    const heart = document.createElement("div");

    heart.className = "wishlist-burst";

    heart.innerHTML = "❤️";

    heart.style.left = x + "px";

    heart.style.top = y + "px";

    document.body.appendChild(heart);

    setTimeout(() => {

        heart.remove();

    }, 900);

}

function showToast(message) {

    let toast = document.querySelector(".wishlist-toast");

    if (!toast) {

        toast = document.createElement("div");

        toast.className = "wishlist-toast";

        document.body.appendChild(toast);

    }

    toast.textContent = message;

    toast.classList.add("show");

    clearTimeout(window.wishlistToast);

    window.wishlistToast = setTimeout(() => {

        toast.classList.remove("show");

    }, 2200);

}